module.exports = __webpack_public_path__ + "images/stickers/pete-award.eb0782174fdd08d4c76a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-award.png
// module id = 40C4
// module chunks = 24